<!--
 * @Author: hjp hjp@hjp.com
 * @Date: 2022-09-15 19:45:43
 * @LastEditors: luodongming
 * @LastEditTime: 2024-12-17 11:35:16
 * @FilePath: \yelink-ecm-developer-web\src\components\DeveloperLogin\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="developer-login">
    <img src="../../assets/images/developer-login/developerPlatformLogo.png" class="logo">
    <main :style="{height: optionHeight}">
      <p>{{ isSelectOrganization ? '选择技术服务商' : '新增技术服务商' }}</p>
      <div v-if="isSelectOrganization === true">
        <el-select v-model="value" placeholder="请选择" filterable>
          <el-option v-for="item in organizationList" :key="item.id" :label="item.organizationName" :value="item.id">
            <span>{{ item.organizationName }}</span>
            <el-tag v-if="item.status === -1" type="danger" style="position: absolute; right: 20px">已失效</el-tag>
          </el-option>
        </el-select>
        <div v-if="!isAuditor" class="add-organization" @click="addOrganization">增加技术服务商</div>
      </div>
      <div v-else-if="isSelectOrganization === false && isAuditor === false">
        <el-form ref="createForm" :model="createForm" :rules="rules" label-position="right" label-width="8rem">
          <el-form-item label="技术服务商名称" prop="organizationName">
            <el-input v-model="createForm.organizationName" placeholder="请输入技术服务商名称" />
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-cascader
              v-model="createForm.address"
              :options="cubeMapOptions"
              :props="{
                value: 'label'
              }"
              placeholder="请选择地址"
              size="medium"
              @change="handleCubeOptionChange"
            />
          </el-form-item>
          <el-form-item prop="detailAddress">
            <el-input v-model="createForm.detailAddress" placeholder="请输入详细地址" />
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="createForm.email" placeholder="请输入邮箱" />
          </el-form-item>
          <el-form-item class="el-form-item-label-offset" label="电话" prop="phone">
            <el-input v-model="createForm.phone" disabled />
          </el-form-item>
          <el-form-item label="验证码" prop="verifyCode">
            <el-input v-model="createForm.verifyCode" placeholder="请输入验证码" />
            <div>
              <el-button
                :disabled="gettingVerifyCode"
                @click="getEmailVerifyCode"
              >
                获取邮箱验证码
              </el-button>
              <span v-if="gettingVerifyCode && countdown > 0">
                <span v-if="countdown >= 60">{{ minutes }} 分钟 </span>
                {{ seconds }} 秒 重新发送
              </span>
            </div>
          </el-form-item>
          <el-form-item class="el-form-item-label-offset" label="描述" prop="description">
            <el-input v-model="createForm.description" type="textarea" :rows="3" placeholder="请输入描述" @input="onInput" />
            <span class="input-count">{{ currentCount }}/256</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <button class="cancel" :disabled="isSending" @click="logout">取消</button>
        <button class="save" :disabled="isSending" @click="selectDeveloperOrganization">
          确认
          <i v-if="isSending" class="el-icon-loading" />
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import { createDeveloperOrganization, getDeveloperOrganization } from '../../api/applet-store/index'
import { getIcubeMap } from '@/api/common'
import { getEmailVerifyCode } from '@/api/developer-organization'
import db from '@/utils/localstorage'

export default {
  components: {},
  data() {
    return {
      organizationList: [],
      value: '',
      isSelectOrganization: true,
      cubeMapOptions: [],
      createForm: {
        address: '',
        detailAddress: '',
        description: '',
        email: '',
        organizationId: '',
        organizationName: '',
        phone: '',
        verifyCode: ''
      },
      currentCount: 0,
      gettingVerifyCode: false,
      countdown: 0,
      timer: null,
      optionHeight: '500px',
      isSending: false,
      isAuditor: false,
      rules: {
        address: [{ required: true, message: '请输入技术服务商地址', trigger: 'blur' }],
        organizationName: [{ required: true, message: '请输入技术服务商名称', trigger: ['blur'] }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        verifyCode: [{ required: true, message: '请输入邮箱验证码', trigger: 'blur' }]
      }
    }
  },
  computed: {
    minutes() {
      return Math.floor(this.countdown / 60)
    },
    seconds() {
      return this.countdown % 60
    }
  },
  watch: {
    isSelectOrganization: {
      handler(val) {
        if (val === false) {
          getIcubeMap().then(res => {
            this.cubeMapOptions = res
          })
          this.optionHeight = '700px'
        } else {
          this.optionHeight = '500px'
        }
      }
    }
  },
  created() {
    if (JSON.parse(localStorage.getItem('USER')).roles.includes('developer_auditor')) {
      this.isAuditor = true
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    this.getDeveloperOrganization()
    const jwt = require('jsonwebtoken')
    const token = db.get('ACCESS_TOKEN')
    this.createForm.phone = jwt.decode(token, { complete: true }).payload.phone_number || ''
  },
  methods: {
    onInput(value) {
      this.currentCount = value.length
      // 当输入字符超过 256 时，截断字符
      if (this.currentCount > 256) {
        this.createForm.description = value.substring(0, 256)
        this.currentCount = 256
      }
    },
    getEmailVerifyCode() {
      if (!this.createForm.email) {
        return this.$message.warning('请输入邮箱')
      }
      this.gettingVerifyCode = true
      getEmailVerifyCode({ email: this.createForm.email }).then(res => {
        this.$message.success('验证码已发送到您的邮箱，请注意查收邮件')
        this.startCountdown()
      }).catch(() => {
        this.$message.error('获取邮箱验证码失败，请重试')
        this.gettingVerifyCode = false
      })
    },
    startCountdown() {
      this.countdown = 300
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.gettingVerifyCode = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
    handleCubeOptionChange(value) {
      this.createForm.address = value
    },
    getDeveloperOrganization() {
      getDeveloperOrganization().then((res) => {
        this.organizationList = res
      })
    },
    selectDeveloperOrganization() {
      if (this.isSelectOrganization) {
        if (!this.value) return this.$message.warning('请选择开发者组织')
        localStorage.setItem('developerOrganizationId', this.value)
        const jwt = require('jsonwebtoken')
        const token = db.get('ACCESS_TOKEN')
        const loginUserName = jwt.decode(token, { complete: true }).payload.preferred_username
        const creatorName = this.organizationList.find(item => item.id === this.value).createdBy
        const organizationName = this.organizationList.find(item => item.id === this.value).organizationName
        localStorage.setItem('loginUserName', loginUserName)
        localStorage.setItem('developerOrganizationCreatorName', creatorName)
        localStorage.setItem('developerOrganizationName', organizationName)
        const currentSelectOrganization = this.organizationList.find(item => item.id === this.value)
        localStorage.setItem('minWeight', currentSelectOrganization.minWeight)
        if (currentSelectOrganization && currentSelectOrganization.status === -1) {
          this.$emit('gotoAuditExamine')
        } else {
          this.$emit('toIndex')
        }
        this.isSelectOrganization = true
      } else {
        this.$refs.createForm.validate((valid) => {
          if (valid) {
            this.isSending = true
            const param = {
              ...this.createForm
            }
            param.address = param.address.toString().replaceAll(',', '/')
            createDeveloperOrganization(param).then(res => {
              localStorage.setItem('developerOrganizationId', res.id) // 注册技术服务商成功后，接口返回技术服务商的详情，将详情中的id存到localStorage中
              this.isSelectOrganization = true
              this.resetCreateForm()
              this.getDeveloperOrganization()
              this.$emit('refreshNotice')
            }).finally(() => {
              this.gettingVerifyCode = false
              this.countdown = 0
              this.isSending = false
              clearInterval(this.timer)
            })
          }
        })
      }
    },
    logout() {
      if (this.isSelectOrganization) {
        this.$store.dispatch('account/keycloakLogout')
      }
      this.isSelectOrganization = true
    },
    addOrganization() {
      this.isSelectOrganization = false
    },
    resetCreateForm() {
      this.createForm = {
        address: '',
        detailAddress: '',
        description: '',
        email: '',
        organizationId: '',
        organizationName: '',
        phone: '',
        verifyCode: ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.developer-login {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(345deg,
      #3569fd 0%,
      #3569fd 19%,
      #3569fd 44%,
      #61a0ff 100%);
  position: relative;

  .logo {
    width: 365px;
    position: absolute;
    top: 60px;
    left: 80px;
  }

  main {
    width: 600px;
    height: 500px;
    background: url('../../assets/images/developer-login/developer-login-background.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 60px;
    box-sizing: border-box;

    p {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      margin: 0;
    }
    ::v-deep .el-cascader {
      width: 100%;
    }
    .el-select {
      width: 100%;
      height: 60px;
      margin: 40px 0 18px;

      ::v-deep .el-input__inner {
        height: 55px;
        font-size: 18px;
      }

      ::v-deep .el-select__caret {
        font-size: 18px;
      }
    }

    .footer {
      width: 100%;
      display: flex;
      justify-content: space-between;

      button {
        width: 180px;
        height: 48px;
        border: 1px solid #3569fd;
        background: #fff;
        color: #3569fd;
        font-size: 22px;
      }

      .save {
        color: #ffffff;
        background: #3569fd;
      }
    }

    .add-organization {
      width: 100%;
      margin: 0 0 100px;
      font-size: 22px;
      color: #3569FD;
    }

    .input-wrapper {
      display: flex;
      flex-direction: column;
      margin: 30px 0 36px;
      row-gap: 2px;
    }

    //.input-wrapper .el-input {
    //  margin-bottom: 22px;
    //}
    .el-form {
      margin: 15px;
    }
    .el-form-item {
      margin-bottom: 20px; /* 根据需要调整数值 */
    }
  }
}

.input-count {
  position: absolute;
  right: 0px;
  bottom: -1.6rem;
  font-size: 12px;
  color: #999
}

.el-form-item-label-offset {
  ::v-deep .el-form-item__label {
    padding-left: 10px;
  }
}
</style>
